import { render, staticRenderFns } from "./InfoCentre.vue?vue&type=template&id=6d636522&scoped=true"
import script from "./InfoCentre.vue?vue&type=script&lang=js"
export * from "./InfoCentre.vue?vue&type=script&lang=js"
import style0 from "./InfoCentre.vue?vue&type=style&index=0&id=6d636522&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d636522",
  null
  
)

export default component.exports